export const GET_APPOINTMENT = "GET_APPOINTMENT";
export const GET_APPOINTMENT_SUCCESS = "GET_APPOINTMENT_SUCCESS";
export const GET_APPOINTMENT_ERROR = "GET_APPOINTMENT_ERROR";
export const GET_APPOINTMENT_CLEAR_DATA = "GET_APPOINTMENT_CLEAR_DATA";


//AppointmentAction
export const GET_APPOINTMENTACTION = "GET_APPOINTMENTACTION";
export const GET_APPOINTMENTACTION_SUCCESS = "GET_APPOINTMENTACTION_SUCCESS";
export const GET_APPOINTMENTACTION_ERROR = "GET_APPOINTMENTACTION_ERROR";
export const GET_APPOINTMENTACTION_CLEAR_DATA = "GET_APPOINTMENTACTION_CLEAR_DATA";
export const APPOINTMENTACTION_PATCH = "GET_APPOINTMENTACTION_PATCH";
export const APPOINTMENTACTION_PATCH_SUCCESS = "APPOINTMENTACTION_PATCH_SUCCESS";
export const APPOINTMENTACTION_PATCH_ERROR = "APPOINTMENTACTION_PATCH_ERROR";
export const APPOINTMENTACTION_PATCH_CLEAR_DATA = "APPOINTMENTACTION_PATCH_CLEAR_DATA";